import React, { useMemo, useState, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

import Card from '../../../components/Card'
import {
  API_CALL_CENTRE_LIST,
  API_CALL_CENTRE_SWITCH_DEFAULT_USER,
  LICENCE_HISTORY_LIST,
} from '../../../service/url';
import { getApiCall } from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import switchUserIcon from '../../../assets/images/icons/switch-user.png';
import { switchUser } from '../../../utilities/setting';
import ToastNotification from '../../../components/Toast';
import { toast } from 'react-toastify';
import { USER_ROLES, MODULE_ACL } from '../../../utilities/constant';
import { ROUTES } from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { useAuth, errorCheck } from '../auth/auth-utils';
import exportData from '../../../utilities/export';
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";
import { getUser } from "../../../utilities/setting";
import { Modal, Dropdown as BootstrapDropdown } from 'react-bootstrap';
import { postApiCall } from '../../../service/httpCall';
import { API_CALL_CENTRE_DELETE } from '../../../service/url';
import LicenceHistoryList from '../licence_history/list';
import { FileText, Flag } from 'lucide-react';
import CountryCodeDirectionsModal from '../../../components/partials/dashboard/country-code-direction/CountryCodeDirectionsModal';



//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';
import Loader  from '../../../components/partials/components/loader';

const CallCentreList = () => {

   const navigate = useNavigate();
   const [callCentreList, setCallCentreList] = useState([]);
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [loading, setLoading] = useState(false);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [currentUserId, setCurrentUserId] = useState("")
   const [currentUserRole, setCurrentUserRole] = useState("")
   const [searchValue, setSearchValue] = useState("");
   const [loggedInUserACL, setLoggedInUserACL] = useState({})
   const [isSuperAdmin, setIsSuperadmin] = useState(false)
   const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [deleteId, setDeleteId] = useState(null);
   const [showLicenceHistoryModal, setShowLicenceHistoryModal] = useState(false);
const [selectedLicenceCallcentreId, setSelectedLicenceCallcentreId] = useState(null);
const [selectedLicenceCallcentreName, setSelectedLicenceCallcentreName] = useState(null);
const [licenceHistoryCounts, setLicenceHistoryCounts] = useState({});
const [showCcDirectionsModal, setShowCcDirectionsModal] = useState(false);
const [ccDirectionsData, setCcDirectionsData] = useState([]);
const [ccDirectionsOwner, setCcDirectionsOwner] = useState("");
const [isSwitchingAccount, setIsSwitchingAccount] = useState(false);

   const formatShortDate = (dateStr) => {
      if (!dateStr) return "—";
      const d = new Date(dateStr);
      if (Number.isNaN(d.getTime())) return "—";
      return d.toLocaleString("en-IN", {
         day: "2-digit",
         month: "short",
         year: "2-digit",
         hour: "2-digit",
         minute: "2-digit",
         hour12: true,
      });
   };

   useEffect(() => {
      const user = getUser();
         if (user) {
            setCurrentUserId(user?.company?.id)
            setCurrentUserRole(user.role)
         }
         if (user.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
   }, []);

   const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "call-centers-list",
         data: displayedCallCentreList,
         columns: [
            {
               header: "#",
               accessor: "key"
            },
            {
               header: "Name",
               accessor: (row) =>
                  row.name || "-"
            },
            {
               header: "Domain",
               accessor: (row) =>
                  row.domain || "-"
            },
            {
               header: "Created Date",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            },
            {
               header: "Updated Date",
               accessor: (row) =>
                  new Date(row.updated_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};

   useEffect( () => {
      setLoading(true);
      getApiCall(API_CALL_CENTRE_LIST, {})
      .then(onCallCentreListSuccess)
      .catch(onError)
      .finally(() => setLoading(false));

   }, []);

   const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});

     useEffect(() => {
      const user = getUser();
         if (user) {
           if (user?.acl_settings) {
             setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
           }
         }
     }, []);

     useEffect(() => {
       const onAclRefreshed = () => {
         const user = getUser();
         if (user?.acl_settings?.module_operations) {
           try {
             const parsed = typeof user.acl_settings.module_operations === "string"
               ? JSON.parse(user.acl_settings.module_operations)
               : user.acl_settings.module_operations;
             setLoggedInUserACL(parsed);
             setModuleOperationsForReadPermissionCheck(parsed);
           } catch (e) {
             console.log("Failed to apply refreshed ACL", e);
           }
         }
       };
       window.addEventListener("acl-refreshed", onAclRefreshed);
       return () => window.removeEventListener("acl-refreshed", onAclRefreshed);
     }, []);

   // useEffect( () => {

   //    if(toastProps){
   //       setShowToast(true);
   //    }

   // }, [toastProps]);


   function onCallCentreListSuccess(resp){
      const updatedList = (Array.isArray(resp) ? resp : []).map((val, idx) => {
         const row = val?.get ? val.get({ plain: true }) : { ...val };
         return { ...row, key: idx + 1 };
      });
      setCallCentreList(updatedList);
    }

   async function switchToDefaultUser(callCentreRow) {
      if (isSwitchingAccount) return;
      const defaultUser = callCentreRow?.defaultUser;
      if (!defaultUser?.id) {
         toast.error("No default user configured for this call centre");
         return;
      }
      if (Number(defaultUser.status) !== 1) {
         toast.error("Default user is inactive");
         return;
      }
      setIsSwitchingAccount(true);
      try {
         const url = API_CALL_CENTRE_SWITCH_DEFAULT_USER.replace(":id", callCentreRow.id);
         const response = await postApiCall(url, {});
         const switchAccountSuccess = await switchUser(response);
         if (switchAccountSuccess) {
            toast.success("Switched to call centre default admin");
            setTimeout(() => {
               window.location.href = ROUTES.DASHBOARD;
            }, 1500);
         }
      } catch (err) {
         toast.error(typeof err === "string" ? err : "Failed to switch user");
         setIsSwitchingAccount(false);
      }
   }

   const defaultUserBody = (rowData) => {
      const defaultUser = rowData.defaultUser;
      const canSwitchDefaultUser =
         Boolean(defaultUser?.id) && Number(defaultUser?.status) === 1;
      const username = defaultUser?.username || "—";

      return (
         <div className="call-centre-list-switch-cell">
            {canSwitchDefaultUser ? (
               <button
                  type="button"
                  className="call-centre-list-switch-btn"
                  title={
                     isSwitchingAccount
                        ? "Switching..."
                        : `Switch to ${username}`
                  }
                  disabled={isSwitchingAccount}
                  onClick={() => switchToDefaultUser(rowData)}
               >
                  <img alt="" src={switchUserIcon} width={22} height={22} />
               </button>
            ) : (
               <span className="call-centre-list-switch-placeholder" aria-hidden />
            )}
            <span className="call-centre-list-switch-username" title={username}>
               {username}
            </span>
         </div>
      );
   };

   const nameBody = (rowData) => (
      <span className="call-centre-list-name" title={rowData.name}>
         {rowData.name || "—"}
      </span>
   );

   const domainBody = (rowData) => {
      const domain = rowData.domain || "—";
      return (
         <span className="call-centre-list-domain" title={domain}>
            {domain.length > 28 ? `${domain.slice(0, 28)}…` : domain}
         </span>
      );
   };

    useEffect(() => {
    if (callCentreList.length === 0) return;

    const fetchCounts = async () => {
        const counts = {};
        await Promise.all(
            callCentreList.map(async (cc) => {
                if (!cc.id) return;
                try {
                    const queryParams = new URLSearchParams();
                    queryParams.append("callcenter_id", cc.id);
                    const url = `${LICENCE_HISTORY_LIST}?${queryParams.toString()}`;
                    const resp = await getApiCall(url);
                    const data = Array.isArray(resp) ? resp : (resp?.data || []);
                    counts[cc.id] = data.length;
                } catch {
                    counts[cc.id] = 0;
                }
            })
        );
        setLicenceHistoryCounts(counts);
    };

    fetchCounts();
}, [callCentreList]);




   const handleAllocateClick = (id, role) => {
      navigate(`/allocate/${id}/${currentUserId}/callcentre`);
    };

    const ccDirectionsTemplate = (rowData) => {
       const rows = (rowData.callcenterCountryCodeDirections || []).filter(
         (r) => r.directionMaster && !r.is_deleted
       );
       if (rows.length === 0) {
         return <span className="call-centre-list-muted">—</span>;
       }
       return (
         <Button
           onClick={() => {
             setCcDirectionsData(rows);
             setCcDirectionsOwner(rowData.name);
             setShowCcDirectionsModal(true);
           }}
           className="p-button-active p-button-sm"
           style={{ padding: "5px 10px", display: "inline-flex", alignItems: "center", gap: "6px" }}
         >
           <Flag size={16} />
           <span>View Codes</span>
         </Button>
       );
    };

    const licenceHistoryTemplate = (rowData) => {
      if (!rowData.id) return "—";
      if (licenceHistoryCounts[rowData.id] === 0) {
        return <span className="call-centre-list-muted">—</span>;
      }
      return (
        <div className="call-centre-list-btn-cell">
          <Button
            label="History"
            icon="pi pi-history"
            onClick={() => {
              setSelectedLicenceCallcentreId(rowData.id);
              setSelectedLicenceCallcentreName(rowData.name);
              setShowLicenceHistoryModal(true);
            }}
            className="p-button-active p-button-sm company-list-license-btn"
          />
        </div>
      );
    };

   function RenderActionComponent(rowData) {
      const id = rowData.id;
      const editUrl = ROUTES.CALL_CENTRES.EDIT.replace(":id", id);

      return (
         <div className="call-centre-list-actions-cell">
         <BootstrapDropdown>
            <BootstrapDropdown.Toggle
               variant="primary"
               size="sm"
               id={`cc-actions-${id}`}
               className="company-list-actions-toggle"
            >
               Actions
            </BootstrapDropdown.Toggle>
            <BootstrapDropdown.Menu
               popperConfig={{
                  modifiers: [
                     { name: "preventOverflow", options: { boundary: "viewport" } },
                     { name: "flip", options: { fallbackPlacements: ["top", "bottom"] } },
                  ],
               }}
            >
               {(isSuperAdmin || loggedInUserACL[MODULE_ACL.CALL_CENTRE]?.edit) && (
                  <BootstrapDropdown.Item onClick={() => navigate(`/${editUrl}`)}>
                     Edit Call Centre
                  </BootstrapDropdown.Item>
               )}
               <BootstrapDropdown.Item onClick={() => handleAllocateClick(id, rowData.name)}>
                  Allocate Number
               </BootstrapDropdown.Item>
               <BootstrapDropdown.Item
                  className="text-danger"
                  onClick={() => openDeleteModal(id)}
               >
                  Delete
               </BootstrapDropdown.Item>
            </BootstrapDropdown.Menu>
         </BootstrapDropdown>
         </div>
      );
   }

   function openDeleteModal(id) {
      setDeleteId(id);
      setShowDeleteModal(true);
   }

   function closeDeleteModal() {
      setDeleteId(null);
      setShowDeleteModal(false);
   }

   async function confirmDelete() {
      try {
         setButtonDisable(true);

         const url = API_CALL_CENTRE_DELETE.replace(":id", deleteId);
         await postApiCall(url, {});
         toast.success("Call centre deleted successfully");

         closeDeleteModal();
         setLoading(true);
         const resp = await getApiCall(API_CALL_CENTRE_LIST, {});
         onCallCentreListSuccess(resp);

      } catch (err) {
         toast.error(JSON.stringify(err) || "Failed to delete call centre");
         onError(err);
      } finally {
         setLoading(false);
         setButtonDisable(false);
      }
   }


function onError(err) {
   if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
    errorCheck(err, navigate, setToastProps, setShowToast)
 } else {
   console.log(err)
 }
}

const handleCreateButtonClick = () => {
   navigate(`/${ROUTES.CALL_CENTRES.CREATE}`);
} 
   
 const displayedCallCentreList = useMemo(() => {
   const q = searchValue.trim().toLowerCase();
   if (!q) return callCentreList;
   return callCentreList.filter((cc) => (cc?.name || "").toLowerCase().includes(q));
 }, [callCentreList, searchValue]);

   const canRead = hasPermission(
     moduleOperationsForReadPermissionCheck,
     "Call Centres List",
     "read",
   );
 
   if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
     return (
       <div
         className="text-center p-4"
         style={{
           marginTop: "50px",
           marginBottom: "50px",
           fontSize: "16px",
         }}
       >
         No read permission found in assigned ACL
       </div>
     );
   }

 if (loading) {
   return <Loader />
}

  return(
     <>
       <div>
         <Row>
            <Col sm="12">
               <Card>
                  <Card.Header className="d-flex justify-content-between">
                     <div className="header-title">
                        <h4 className="card-title">Call Centre List</h4>
                     </div>
                     {(isSuperAdmin || loggedInUserACL[MODULE_ACL.CALL_CENTRE]?.add) && (
                        <button className="btn btn-primary ml-auto" onClick={handleCreateButtonClick}>Create Call Centre</button>
                     )}
                  </Card.Header>
                  <Card.Body className="px-0">
                     {callCentreList.length > 0 &&
                     <Button 
                     label="Export Data"
                     icon="pi pi-file-export"
                     onClick={handleExport} 
                     className="p-button-active p-button-sm" 
                     style={{ marginBottom: '10px', marginLeft: '10px' }} 
                     disabled={buttonDisable} 
                  >
                     &nbsp;
                     {buttonDisable && (
                        <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                     )}
                  </Button>

                     }

                     <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                        <Form.Group style={{ marginLeft: "10px", marginTop: "10px", marginBottom: "10px", flexShrink: 0 }}>
                           <Form.Control
                              style={{
                                 height: "50px",
                                 width: "380px",
                                 border: "1px solid #ced4da",
                                 fontSize: "15px",
                              }}
                              placeholder="Search call centre by name..."
                              type="text"
                              maxLength={100}
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                           />
                        </Form.Group>
                     </div>
                     
                     <div className="scroll-container">
                        <div className="table-responsive border-bottom my-3">
                           <DataTable
                              value={displayedCallCentreList}
                              paginator
                              rows={8}
                              className={`call-centre-list-datatable company-list-datatable${
                                 displayedCallCentreList.length < 3 &&
                                 displayedCallCentreList.length > 0
                                    ? " increasePaddingBottom"
                                    : ""
                              }`}
                           >
                              <Column
                                 field="key"
                                 header="#"
                                 align="center"
                                 headerClassName="call-centre-list-col call-centre-list-col--index"
                                 bodyClassName="call-centre-list-col call-centre-list-col--index"
                                 style={{ width: "4%" }}
                              />
                              <Column
                                 header="Name"
                                 body={nameBody}
                                 align="left"
                                 headerClassName="call-centre-list-col call-centre-list-col--name"
                                 bodyClassName="call-centre-list-col call-centre-list-col--name"
                                 style={{ width: "13%" }}
                              />
                              <Column
                                 header="Domain"
                                 body={domainBody}
                                 align="left"
                                 headerClassName="call-centre-list-col call-centre-list-col--domain"
                                 bodyClassName="call-centre-list-col call-centre-list-col--domain"
                                 style={{ width: "17%" }}
                              />
                              <Column
                                 header="Country"
                                 body={ccDirectionsTemplate}
                                 align="center"
                                 headerClassName="call-centre-list-col call-centre-list-col--btn"
                                 bodyClassName="call-centre-list-col call-centre-list-col--btn"
                                 style={{ width: "11%" }}
                              />
                              <Column
                                 header="Licence"
                                 body={licenceHistoryTemplate}
                                 align="center"
                                 headerClassName="call-centre-list-col call-centre-list-col--btn"
                                 bodyClassName="call-centre-list-col call-centre-list-col--btn"
                                 style={{ width: "11%" }}
                              />
                              <Column
                                 header="Updated"
                                 body={(rowData) => formatShortDate(rowData.updated_at)}
                                 align="left"
                                 headerClassName="call-centre-list-col call-centre-list-col--updated"
                                 bodyClassName="call-centre-list-col call-centre-list-col--updated"
                                 style={{ width: "14%" }}
                              />
                              <Column
                                 header="Default User"
                                 body={defaultUserBody}
                                 align="left"
                                 headerClassName="call-centre-list-col call-centre-list-col--default-user"
                                 bodyClassName="call-centre-list-col call-centre-list-col--default-user"
                                 style={{ width: "18%" }}
                              />
                              <Column
                                 header="Actions"
                                 body={RenderActionComponent}
                                 align="center"
                                 headerClassName="call-centre-list-col call-centre-list-col--actions"
                                 bodyClassName="call-centre-list-col call-centre-list-col--actions"
                                 style={{ width: "12%" }}
                              />
                           </DataTable>
                        </div>
                     </div>
                  </Card.Body>
                  
               </Card>
            </Col>
         </Row>
      </div>
      <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
   <Modal.Header closeButton>
      <Modal.Title>Delete Call Centre</Modal.Title>
   </Modal.Header>

   <Modal.Body>
      Are you sure you want to delete this call centre? Licence Values cannot be returned.
   </Modal.Body>

   <Modal.Footer>
      <Button
         label="Cancel"
         className="p-button-text"
         onClick={closeDeleteModal}
      />

      <Button
         label="Delete"
         className="p-button-danger"
         onClick={confirmDelete}
         disabled={buttonDisable}
      />
   </Modal.Footer>
</Modal>

      {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}


<Modal
    show={showLicenceHistoryModal}
    onHide={() => {
        setShowLicenceHistoryModal(false);
        setSelectedLicenceCallcentreId(null);
        setSelectedLicenceCallcentreName(null);
    }}
    centered
    size="xl"
    dialogClassName="callcentre-licence-history-modal"
>
    <style>{`
        .callcentre-licence-history-modal .modal-header {
            background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
            color: white !important;
            border-bottom: none !important;
            border-radius: 14px 14px 0 0 !important;
            padding: 18px 24px !important;
        }
        .callcentre-licence-history-modal .modal-title {
            color: white !important;
            font-size: 20px !important;
            font-weight: 600 !important;
            margin: 0 !important;
        }
        .callcentre-licence-history-modal .btn-close {
            filter: brightness(0) invert(1) !important;
            opacity: 0.8 !important;
        }
        .callcentre-licence-history-modal .modal-content {
            border-radius: 14px !important;
            overflow: hidden;
            box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
        }
        .callcentre-licence-history-modal .modal-body {
            padding: 16px !important;
            max-height: 75vh;
            overflow-y: auto;
        }
    `}</style>
    <Modal.Header>
        <Modal.Title>
            Licence History — {selectedLicenceCallcentreName}
        </Modal.Title>
        <button
            type="button"
            className="btn-close btn-close-white"
            onClick={() => {
                setShowLicenceHistoryModal(false);
                setSelectedLicenceCallcentreId(null);
                setSelectedLicenceCallcentreName(null);
            }}
            aria-label="Close"
        />
    </Modal.Header>
    <Modal.Body>
        {selectedLicenceCallcentreId && (
            <LicenceHistoryList callcenterId={selectedLicenceCallcentreId}
            displayName={selectedLicenceCallcentreName} />
        )}
    </Modal.Body>
</Modal>

<CountryCodeDirectionsModal
  show={showCcDirectionsModal}
  onHide={() => {
    setShowCcDirectionsModal(false);
    setCcDirectionsData([]);
    setCcDirectionsOwner("");
  }}
  title="Call Centre Country Codes"
  ownerLabel="Call Centre Name"
  ownerName={ccDirectionsOwner}
  directions={ccDirectionsData}
/>
     </>
  )

}

export default CallCentreList;